export enum AuthClientId {
  SINGLEBOX = 'singlebox',
  /** Dev builds of Singlebox register `singlebox-dev://` instead of `singlebox://`. */
  SINGLEBOX_DEV = 'singlebox-dev',
  DESKTOP = 'desktop',
  /** Dev builds of WebCatalog register `webcatalog-dev://` instead of `webcatalog://`. */
  DESKTOP_DEV = 'desktop-dev',
  ACCOUNT = 'account',
  /** The auth UI reading its own session; it never starts a login flow. */
  AUTH = 'auth',
  ADMIN = 'admin',
  ATLAS = 'atlas',
  /** The retired developer console, still deployed on Cloudflare: it signs
   * in with this `client_id` until its Worker is deleted. */
  CONSOLE = 'console',
  /** Value must stay `web`: it is already registered as a `client_id`. */
  MARKETING = 'web',
  /** Value must stay `atlas-webext`: deployed extensions send it as `client_id`. */
  WEBEXT = 'atlas-webext',
}
